<template>
  <div>
    <p class="crm-kicker">Suivi</p>
    <h1 class="crm-title">À faire</h1>
    <p class="crm-hint">Relances & actions ouvertes</p>
    <div v-if="loading" class="crm-hint">Chargement…</div>
    <div v-else>
      <div v-for="t in todos" :key="t.id" class="crm-card" style="margin-bottom:10px">
        <div style="display:flex;gap:10px;align-items:flex-start">
          <router-link :to="ficheLink(t.id)" style="flex:1;min-width:0;color:inherit;text-decoration:none">
            <div class="crm-row-title">{{ t.label || t.societe }}</div>
            <div class="crm-row-meta">{{ metaLine(t) }}</div>
            <p v-if="t.todo_action" class="crm-note" style="margin:10px 0 0;white-space:pre-wrap">{{ t.todo_action }}</p>
          </router-link>
          <div style="display:flex;flex-direction:column;gap:6px;align-items:stretch;flex-shrink:0">
            <a v-if="t.telephone" class="crm-badge ok" :href="'tel:' + t.telephone" style="text-align:center">Appeler</a>
            <button
              type="button"
              class="crm-btn crm-btn-primary"
              style="min-height:36px;padding:6px 14px;font-size:13px"
              :disabled="completingId === t.id"
              @click="complete(t)"
            >{{ completingId === t.id ? '…' : 'Valider' }}</button>
          </div>
        </div>
      </div>
      <div v-if="!todos.length" class="crm-card">
        <p class="crm-hint" style="margin:0">Rien en attente</p>
      </div>
    </div>
  </div>
</template>

<script>
import { withFrom } from './crmSalonUtils'

export default {
  name: 'CrmSalonAFaire',
  data() {
    return { todos: [], loading: false, completingId: null }
  },
  mounted() { this.load() },
  methods: {
    ficheLink(id) {
      return withFrom('/crm-salon/fiche/' + id, this.$route.fullPath)
    },
    metaLine(t) {
      return [t.next_action || t.pipeline, t.societe].filter(Boolean).join(' · ')
    },
    async load() {
      this.loading = true
      try {
        const { data } = await this.$apollo.query({
          client: 'AUTH',
          query: require('src/graphql/auth/crmSalon/crmSalonTodos.gql'),
          fetchPolicy: 'network-only'
        })
        this.todos = data.crmSalonTodos || []
      } finally {
        this.loading = false
      }
    },
    async complete(t) {
      if (!t || !t.id) return
      this.completingId = t.id
      try {
        await this.$apollo.mutate({
          client: 'AUTH',
          mutation: require('src/graphql/auth/crmSalon/crmSalonCompleteTodo.gql'),
          variables: { prospect_id: String(t.id) }
        })
        this.todos = this.todos.filter((x) => x.id !== t.id)
      } catch (e) {
        /* keep row */
      } finally {
        this.completingId = null
      }
    }
  }
}
</script>
